export default __webpack_public_path__ + "static/media/Josie.685d41a2.png";